import React, { useEffect, useState } from 'react'
import useApi from 'hooks/useApi';
import { useAuth } from 'context/AuthProvider';
import ListCentros from './ListCentros';
import { apiCentrosService } from 'services/apiCentrosService';

const ListCentrosImpl = () => {

  const {empresa} = useAuth();
  const [content, setContent] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  
  //const { data, loading, error } = useApi(apiCentrosService.getAllPageable(empresa.id,currentPage,10));
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () =>{
      const response = await apiCentrosService.getAllPageable(empresa.id,currentPage,10)
       
      setContent(response.content);
      setTotalPage(response.totalPages);
    }
    setLoading(true)
    fetchData();
    setLoading(false)
  }, []);

  
  
  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
    {content && 
   <ListCentros centros={content} currentPage={currentPage} setCurrentPage={setCurrentPage} totalPage={totalPage}/>}
   </>
  );
}


export default ListCentrosImpl